var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFord(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.206,
    height: 27.683,
    viewBox: "0 0 73.206 27.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-5{opacity:.55}.cls-2{fill:#1f5ea7}.cls-2,.cls-3,.cls-4{fill-rule:evenodd}.cls-3{fill:#fff}.cls-4{fill:#455e97}.cls-6{opacity:.533;clip-path:url(#clip-path)}.cls-7{fill:#6282b3}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    d: "M40.34 52.064c18.865 0 34.142-5.126 34.142-11.483S59.2 29.2 40.34 29.2 6.3 34.326 6.3 40.581c0 6.357 15.277 11.483 34.04 11.483z",
    className: "cls-1",
    "data-name": "Trazado 412",
    transform: "translate(-6.3 -29.2)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ford-color",
    transform: "translate(-3.8 -26.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    d: "M40.4 54.483c20.2 0 36.6-6.152 36.6-13.841S60.6 26.8 40.4 26.8 3.8 33.054 3.8 40.641c0 7.69 16.4 13.841 36.6 13.841z",
    className: "cls-2",
    "data-name": "Trazado 408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    d: "M40.367 53.014C20.989 53.014 5.2 47.478 5.2 40.609S20.989 28.1 40.367 28.1c19.48 0 35.167 5.639 35.167 12.509.1 6.869-15.687 12.406-35.167 12.406z",
    className: "cls-3",
    "data-name": "Trazado 409",
    transform: "translate(.035 .033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    d: "M40.34 52.064c18.865 0 34.142-5.126 34.142-11.483S59.2 29.2 40.34 29.2 6.3 34.326 6.3 40.581c0 6.357 15.277 11.483 34.04 11.483z",
    className: "cls-2",
    "data-name": "Trazado 410",
    transform: "translate(.063 .061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    d: "M36.1 37.438s.205 0 .615-.41c.1-.1.41-.615.308-.82a.327.327 0 0 0-.308-.308c-.308.1-.615.205-.615.615a1.414 1.414 0 0 0 0 .923z",
    className: "cls-4",
    "data-name": "Trazado 411",
    transform: "translate(.815 .23)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_180",
    className: "cls-5",
    "data-name": "Grupo 180",
    transform: "translate(6.363 29.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_179",
    className: "cls-6",
    "data-name": "Grupo 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_414",
    d: "M0 0h68.182v11.381H0z",
    className: "cls-7",
    "data-name": "Rect\\xE1ngulo 414",
    transform: "translate(0 -1.128)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_181",
    "data-name": "Grupo 181",
    transform: "translate(19.794 31.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    d: "M48.76 42.662c1.64-1.538 2.461-3.076 4.819-3.076a2 2 0 0 1 1.948 1.64L58.6 36.1h1.846l-5.024 8.92a1.958 1.958 0 0 0-.308.82c0 .41.615.308.41.308 1.025 0 2.871-1.948 3.281-2.461l.308-.308c.1 0 .308.1.308.205a1.56 1.56 0 0 1-.41.615c-.923 1.23-2.461 2.973-4.306 3.076-.923 0-1.23-.308-1.333-1.025a6.139 6.139 0 0 1-3.178.923 1.886 1.886 0 0 1-1.846-1.23 2.477 2.477 0 0 1-.1-1.743 3.361 3.361 0 0 1-2.051.308 1.877 1.877 0 0 1-1.948-1.64c-1.128 2.051-1.23 2.153-2.358 4.306H39.84l2.56-4.41a6 6 0 0 0 .615-1.538c.1-.308-.1-.513-.41-.615a2.621 2.621 0 0 0-1.435.82 24.239 24.239 0 0 0-2.253 2.869c-.923 1.333-2.461 2.973-4.2 2.973a2.632 2.632 0 0 1-2.666-2.051s-.1.308-1.23.923c-.1 0-.308.205-.41.1a.886.886 0 0 1-.308-.615c.1 0 .205-.1.615-.41a2.137 2.137 0 0 0 1.025-1.23c.205-.41.615-1.128.82-1.64a4.77 4.77 0 0 1 3.9-2.973.474.474 0 0 1 .513.308c.205.1.1.41.1.41a4.428 4.428 0 0 0-2.976 1.849 6.552 6.552 0 0 0-.82 1.948 1.616 1.616 0 0 0 1.128 1.948c1.333.205 2.461-.82 3.383-2.358a6.067 6.067 0 0 0 .41-2.051A2.637 2.637 0 0 0 37.687 40a.591.591 0 0 1 .615-.615.377.377 0 0 1 .308.1 2.955 2.955 0 0 1 .718 2.051v.718c1.025-1.23 2.256-2.768 3.178-3.076a1.3 1.3 0 0 1 .615-.1 1.36 1.36 0 0 1 1.538 1.538c.923-1.128 1.64-1.538 2.461-1.435a1.174 1.174 0 0 1 1.23 1.23 1.338 1.338 0 0 1-1.23 1.333 1.247 1.247 0 0 1-1.333-.923 1.321 1.321 0 0 0-.718 1.128A1.2 1.2 0 0 0 46.3 43.38a2.3 2.3 0 0 0 2.461-.718z",
    className: "cls-3",
    "data-name": "Trazado 413",
    transform: "translate(-19.129 -31.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    d: "M50.26 32.633c0 .718-2.666 2.153-4.921 2.153-3.486 0-7.177-1.64-8.817-2.051a24.891 24.891 0 0 0-4.819-.82c-4.511 0-6.562 1.948-6.459 3.794 0 .718.615 1.23 1.538 1.025a4.03 4.03 0 0 0 2.563-1.846c.1-.205.308-.205.308-.1a.506.506 0 0 1 .1.308c-.1.923-1.538 3.486-4 3.486a2.417 2.417 0 0 1-2.253-2.566c0-2.358 2.358-4.716 8.3-4.716a24.4 24.4 0 0 1 3.691.308 63.781 63.781 0 0 0 8.715 1.025c1.23 0 2.666 0 3.9-.1 1.333-.205 1.025-.308 1.538-.308.615 0 .615.205.615.41z",
    className: "cls-3",
    "data-name": "Trazado 414",
    transform: "translate(-19.296 -31.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    d: "M53.089 40.6c-.82-.1-1.846.615-2.666 1.64a4.459 4.459 0 0 0-.923 2.153 1.506 1.506 0 0 0 .308 1.333c.205.205 1.128.615 2.666-.82a14.163 14.163 0 0 0 1.64-2.153l-.308-.1c.41-.923.308-1.948-.718-2.051z",
    className: "cls-2",
    "data-name": "Trazado 415",
    transform: "translate(-18.64 -31.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    d: "M36.625 38.032a.574.574 0 0 0 .615.513c-.1.308 0 .41-.205.308a1.209 1.209 0 0 1-1.025-.718 35.256 35.256 0 0 1-3.691.513c-4.716 7.587-6.152 8.817-9.023 8.817a3.683 3.683 0 0 1-3.9-3.794 4.137 4.137 0 0 1 3.383-3.794c.308 0 .308.1.308.205s-.1.205-.308.308a3.476 3.476 0 0 0-1.743 2.666 2.007 2.007 0 0 0 1.435 2.051 1.675 1.675 0 0 0 .718 0c2.256 0 4.819-2.563 7.69-6.459-.41 0-2.358.205-2.871.82-.205.205-.308.1-.41-.1a1.033 1.033 0 0 0 .1-.308c.718-.82 2.973-1.025 3.589-1.128 2.153-3.281 4.819-5.331 5.434-5.229.1 0 .308.1.205.41 0 0-.308.308-.308.41a13.52 13.52 0 0 0-3.794 4.409c1.435-.1 3.076-.308 3.076-.308a2.235 2.235 0 0 1-.1-.615c.1-1.025.615-1.64 1.435-1.538a.87.87 0 0 1 .718.82 1.787 1.787 0 0 1-.615 1.23 1.839 1.839 0 0 1-.718.513z",
    className: "cls-3",
    "data-name": "Trazado 416",
    transform: "translate(-19.4 -31.265)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFord);
export default __webpack_public_path__ + "static/media/ford.cba932606fc3829d8867280e5fac5df4.svg";
export { ForwardRef as ReactComponent };